import React from 'react';
import { FlexMiddle } from '../../Flex';

const ClockSourceChip = ({ externalOptions = {}, value }) => {
  const selectedValues = value ? (Array.isArray(value) ? value : [value]) : [];

  return (
    <FlexMiddle>
      {(externalOptions.clockSource || [])
        .filter(({ value: optionValue }) => selectedValues.includes(optionValue))
        .map(({ label }) => label)
        .join(', ')}
    </FlexMiddle>
  );
};

export default ClockSourceChip;
